module.exports = __webpack_public_path__ + "img/cooper-logo.d3db14f7.jpg";